module.exports = "<app-header></app-header>\n<div class=\"app-container\">\n  <router-outlet></router-outlet>\n</div>\n<app-footer></app-footer>"